import './Dashboard.css';
const Dashboard = () => {
    return (
        <div className='dashboard-main'>
            {/* <h1>Dashboard</h1> */}
        </div>
    );
}

export default Dashboard;